import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import NoResultsFoundIcon from "assets/customIcons/emptyTable/NoResultsFoundIcon";
import { body1SemiBold, body2Regular } from "shared";

const NoNotifications = () => {
    const { gray700 } = colors;

    const { t } = useTranslation();

    return (
        <div
            css={css({
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                padding: "32px"
            })}
        >
            <NoResultsFoundIcon
                css={css({
                    fontSize: "120px"
                })}
            />

            <div css={[body1SemiBold, { margin: "16px 0 8px 0" }]}>
                {t("Notifications##no notifications")}
            </div>

            <div css={[body2Regular, { color: gray700 }]}>
                {t(`Notifications##notifications will be listed`)}
            </div>
        </div>
    );
};

export default NoNotifications;
